export enum DownloadCareerTypes {
  FETCH_DOWNLOAD_CAREER_SUCCESS = "FETCH_DOWNLOAD_CAREER_SUCCESS",
  FETCH_DOWNLOAD_CAREER_FAILURE = "FETCH_DOWNLOAD_CAREER_FAILURE",
  FETCH_DOWNLOAD_CAREER_REQUEST = "FETCH_DOWNLOAD_CAREER_REQUEST"
}